import React, {useEffect, useState} from 'react';
import HeaderAudit from '../commons/headerAudit';
import {InventorySearchCard} from './inventorySearchCard';
import TableAudit from './table/tableAudit';
import {connect} from 'react-redux';
import {Dimmer, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {columnsVehicles} from './table/columnsVehicle';
import {columnsClient} from './table/columnClient';

const AuditFloatingInventory = ({
  cleanFloatingAuditScreen,
  dataFloatingInventory,
  dataFloatingClient,
  loading,
  updateTable,
  floatingClientList,
  floatingInventoryList,
}) => {
  const [currentScreen, setCurrentScreen] = useState('FL_INV');
  const [resetAllFilters, setResetAllFilters] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (currentScreen === 'FL_INV') {
      setData(dataFloatingInventory);
      setColumns(columnsVehicles);
    } else {
      setData(dataFloatingClient);
      setColumns(columnsClient);
    }
  }, [dataFloatingInventory, dataFloatingClient]);
  
  useEffect(() => {
    return () => cleanFloatingAuditScreen();
  }, []);
  
  return <>
    <Dimmer
      inverted
      active={loading}
      style={{
        'width': '100%',
        'height': '100%',
        'position': 'fixed',
        'top': '0',
        'background': 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <Loader size='large'/>
    </Dimmer>
    <HeaderAudit
      currentScreen={currentScreen}
      setCurrentScreen={setCurrentScreen}
      cleanFloatingAuditScreen={cleanFloatingAuditScreen}
    />
    <InventorySearchCard
      resetAllFilters={resetAllFilters}
      showFilters={showFilters}
      setResetAllFilters={setResetAllFilters}
      setShowFilters={setShowFilters}
      currentScreen={currentScreen}
      floatingClientList={floatingClientList}
      floatingInventoryList={floatingInventoryList}
    />
    <TableAudit
      columnsTable={columns}
      dataTable={data}
      updateTable={updateTable}
      resetAllFilters={resetAllFilters}
      setResetAllFilters={setResetAllFilters}
      showFilters={showFilters}
      currentScreen={currentScreen}
    />

  </>;
};

const mapStateToProps = (state) => {
  return {
    'loading': state.floatingInventoryAudit.loading,
    'dataFloatingInventory': state.floatingInventoryAudit.dataFloatingInventory,
    'dataFloatingClient': state.floatingInventoryAudit.dataFloatingClient,
    'updateTable': state.floatingInventoryAudit.updateTable,
    'floatingClientList': state.floatingInventoryAudit.floatingClientList,
    'floatingInventoryList': state.floatingInventoryAudit.floatingInventoryDropDownList,
  };
};

const {
  cleanFloatingAuditScreen,
} = Actions;

export default connect(mapStateToProps, {cleanFloatingAuditScreen})(AuditFloatingInventory);
